import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HomeBanner from '../Components/HomeBanner';
import MainNav from '../Components/MainNav';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Footer from '../Components/Footer';
import axios from 'axios';
import config from '../config';
import entrior from "../Images/inter.jpg";
import extrior from "../Images/exter.jpg";
import am from "../Images/am.jpg";

const HIGHLIGHTS = [
  { value: '25+', label: 'Years of Heritage' },
  { value: '9', label: 'Unique Dining Spaces' },
  { value: '500+', label: 'Events Hosted' },
];

function Home() {
  const [restaurantData, setRestaurantData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios
      .get(`${config.API_BASE_URL}/api/home`)
      .then((response) => {
        setRestaurantData(response.data);
        setError(false);
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="home-page-wrapper">
        <MainNav />
        <div className="haveli-page-loader">
          <div className="haveli-page-loader__ring" />
          <p className="haveli-page-loader__text">Haveli Restaurant</p>
          <span className="haveli-page-loader__sub">Loading experience…</span>
        </div>
      </div>
    );
  }

  const cardData = [
    {
      title: restaurantData?.atmospheric_imager_heading_1 || 'Atmospheric Dining',
      img: am,
    },
    {
      title: restaurantData?.atmospheric_imager_heading_2 || 'Interior Elegance',
      img: entrior,
    },
    {
      title: restaurantData?.atmospheric_imager_heading_3 || 'Exterior Charm',
      img: extrior,
    },
  ];

  const headingName = restaurantData?.heading_name || 'Welcome to Haveli';
  const description = restaurantData?.description || (
    '<p>Experience the grandeur of Lahore\'s heritage at Haveli Restaurant — authentic cuisine, stunning architecture, and unforgettable moments in the Walled City.</p>'
  );
  const sectionHeading = restaurantData?.atmospheric_imager_heading || 'Experience Haveli';

  return (
    <div className="home-page-wrapper">
      <MainNav />
      <HomeBanner />

      <section id="welcome" className="welcom-wrapper">
        <span className="section-label">Our Story</span>
        <h2>{headingName}</h2>
        <div className="welcome-divider" aria-hidden="true" />
        <div className="welcome-body" dangerouslySetInnerHTML={{ __html: description }} />
      </section>

      <section className="home-stats" aria-label="Highlights">
        <Container>
          <Row className="g-4 justify-content-center">
            {HIGHLIGHTS.map((item) => (
              <Col xs={4} md={4} key={item.label} className="text-center">
                <div className="home-stat">
                  <span className="home-stat__value">{item.value}</span>
                  <span className="home-stat__label">{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Container className="page-content">
        <span className="section-label section-label--center">Discover</span>
        <h2 className="page-heading mb-5">{sectionHeading}</h2>
        <Row>
          {cardData.map((card, index) => (
            <Col md={4} key={index} className="mb-4">
              <Card className="d_card haveli-experience-card">
                <span className="d_card__index">0{index + 1}</span>
                <div
                  className="card-image"
                  style={{ backgroundImage: `url(${card.img})` }}
                />
                <Card.Body className="content">
                  <Card.Title className="heading">{card.title}</Card.Title>
                  <Link to="/dining-experience" className="d_card__link">
                    Learn more →
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      <section className="home-cta">
        <Container>
          <div className="home-cta__inner">
            <span className="section-label">Plan Your Visit</span>
            <h2>Host Your Next Celebration at Haveli</h2>
            <p>
              From intimate dinners to grand weddings — our team crafts every detail with Lahori warmth and royal elegance.
            </p>
            <div className="home-cta__actions">
              <Link to="/contact" className="hero-btn hero-btn--primary">
                Get in Touch
              </Link>
              <Link to="/catering" className="hero-btn hero-btn--outline">
                Events &amp; Catering
              </Link>
            </div>
          </div>
        </Container>
      </section>

      {error && (
        <p className="home-api-notice text-center text-muted small py-2">
          Live content unavailable — showing curated preview.
        </p>
      )}

      <Footer />
    </div>
  );
}

export default Home;
